/**
 * Enum for fiscal docs status.
 * @readonly
 * @enum {String} FiscalDocStatusEnum
 */

const FiscalDocStatusEnum = {
  CLOSED              : 'closed',
  OPEN                : 'open',
  AWAITING            : 'awaiting',
  TRANSMITTED         : 'transmitted',
  TRANSMISSION_FAILURE: 'transmission_failure',
  CANCELED            : 'canceled'
}

export default FiscalDocStatusEnum
